import { Injectable } from '@angular/core';
import { Bandeira } from '../models/bandeira.enum';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class BannerPortalService {
  private url = `${environment.apiURLService}/v1`;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private apiService: ApiService
  ) { }

  async getImageBannerPortalUrl(bandeira: Bandeira): Promise<SafeResourceUrl> {
    const url = `${this.url}/cobranca-orquestrador-registro/cobrancas/banner/homePortal/download?bandeira=${bandeira}`;

    const path = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-orquestrador-registro',
      path: `/cobranca-orquestrador-registro/cobrancas/banner/homePortal/download?bandeira=${bandeira}`,
      oldBrowserFallbackPath: `/cobrancas/banner/homePortal/download?bandeira=${bandeira}`
    })

    const response = await this.http.get(path, { responseType: 'arraybuffer' }).toPromise();
    const blob = new Blob([response], { type: 'image/png' });

    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
  }
}
